<template>
 <div
   class="inline-flex items-start text-sm tracking-tighter cursor-pointer mt-1"
   :class="{ 'text-violet-600 font-bold': checked }"
 >
   <label>
     <span
       class="w-[13px] h-[13px] p-[2px] inline-flex items-center justify-center rounded-sm relative mr-1 before:rounded-sm before:absolute before:w-full before:h-full before:left-0 before:top-0 before:bottom-0 before:right-0 before:border before:border-gray-03"
     >
       <em
         class="w-full h-full rounded-sm"
         :class="checked ? 'bg-violet-500' : 'bg-gray-03'"
       ></em>
     </span>
     <input
       type="checkbox"
       hidden
       :value="value"
       :checked="checked"
       @change="onInputChange"
     />
   </label>
   <span @click="onInputChange(); $emit('onClick', label)">
     {{ label }}
   </span>
 </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
 label: {
   type: String,
   default: '',
 },
 modelValue: {
   type: [String, Number, Boolean, Array],
   default: false,
 },
 value: {
   type: [String, Number, Boolean],
 },
});

const emits = defineEmits(['update:model-value', 'onClick']);

// `checked`는 boolean 값을 유지
const checked = computed(() => {
 if (Array.isArray(props.modelValue)) {
   return props.modelValue.includes(props.value);
 }
 if (typeof props.value === 'boolean') {
   return props.value ? props.modelValue === props.value : props.modelValue;
 }
 return +props.modelValue === +props.value;
});

// 변경된 값 처리
const onInputChange = () => {
 let newValue;
 if (Array.isArray(props.modelValue)) {
   newValue = checked.value
     ? props.modelValue.filter((val) => val !== props.value)
     : [...props.modelValue, props.value];
 } else if (typeof props.modelValue === 'boolean') {
   newValue = !props.modelValue;
 } else {
   newValue = props.value;
 }
 emits('update:model-value', newValue);
};
</script>
